/* global $:false */

const HEADER_HEIGHT = 140

export const initAnchor = ({ selector }) => {
  const $anchors = $(selector)
  const $body = $('body')
  for (let i = 0; i < $anchors.length; i++) {
    const $anchor = $anchors.eq(i)
    const $target = $($anchor.data('anchor'))
    const center = $target.offset().top + $target.height() / 2
    const scrollTop = center - document.documentElement.clientHeight / 2 - HEADER_HEIGHT / 2
    $anchor.on('click', () => {
      $body.animate({
        scrollTop
      }, {
        duration: 300
      })
    })
  }
}
